import React, { FC, useState, useRef } from 'react';

import {
  Container,
  Button,
  useClickOutside,
  ContainerProps,
} from '@lglp/components';
import { usePopper } from 'react-popper';

import styles from './Tooltip.module.scss';

export type TooltipComponentProps = ContainerProps & {
  text: string;
  tooltipTitle?: string;
  tooltipText: string;
};

export const Tooltip: FC<TooltipComponentProps> = ({
  text,
  tooltipTitle,
  tooltipText,
  className,
}) => {
  const [visible, setVisibility] = useState(false);

  const buttonRef = useRef(null);
  const popperRef = useRef(null);

  const [arrowRef, setArrowRef] = useState(null);

  const { styles: popperStyles, attributes } = usePopper(
    buttonRef.current,
    popperRef.current,
    {
      placement: 'top-start',
      modifiers: [
        {
          name: 'arrow',
          options: {
            element: arrowRef,
            padding: 0,
          },
        },
        {
          name: 'offset',
          options: { offset: [0, 22] },
        },
        {
          name: 'flip',
          options: {
            allowedAutoPlacements: ['top', 'bottom'],
          },
        },
        {
          name: 'preventOverflow',
          options: {
            padding: 16,
          },
        },
      ],
    }
  );

  useClickOutside(() => {
    setVisibility(false);
  }, popperRef);

  const handleClick = () => {
    setVisibility(!visible);
  };

  return (
    <Button
      as="span"
      className={[styles.tooltip, className]}
      onClick={handleClick}
      innerRef={buttonRef}
    >
      {text}
      {visible && (
        <Container
          as="span"
          innerRef={popperRef}
          style={popperStyles.popper}
          className={styles.tooltipContentContainer}
          {...attributes.popper}
        >
          <Container as="span" className={styles.tooltipContent}>
            {tooltipTitle && (
              <Container as="span" className={styles.tooltipTitle}>
                {tooltipTitle}
              </Container>
            )}
            {tooltipText}
          </Container>
          <Container
            as="span"
            innerRef={setArrowRef}
            className={styles.arrow}
          />
        </Container>
      )}
    </Button>
  );
};
